import { api } from './api';
import {
  MantraJapa,
  MantraJapaFolder,
  CreateMantraJapaPayload,
  UpdateMantraJapaPayload,
  CreateMantraJapaFolderPayload,
  UpdateMantraJapaFolderPayload,
} from '../types';

export interface MantraJapaQueryParams {
  bidhiId?: number | string;
  mediaGroupId?: number | string;
  folderId?: number | string;
  search?: string;
}

function unwrapList<T>(data: unknown): T[] {
  if (Array.isArray(data)) return data as T[];
  if (data && typeof data === 'object') {
    const record = data as Record<string, unknown>;
    if (Array.isArray(record.data)) return record.data as T[];
    if (Array.isArray(record.items)) return record.items as T[];
  }
  return [];
}

export const mantraJapaApi = {
  /**
   * List all mantra-japas. Supports query params: ?bidhiId=, ?mediaGroupId=, ?folderId=, ?search=
   */
  getAll: (params?: MantraJapaQueryParams) =>
    api.get<MantraJapa[]>('/mantra-japa', { params }).then((res) => {
      const data = unwrapList<MantraJapa>(res.data);
      return { ...res, data };
    }),

  /**
   * Get single mantra-japa with populated media group and bidhi details
   */
  getById: (id: number | string) =>
    api.get<MantraJapa>(`/mantra-japa/${id}`),

  /**
   * Create a new mantra-japa
   */
  create: (payload: CreateMantraJapaPayload) =>
    api.post<MantraJapa>('/mantra-japa', payload),

  /**
   * Partially update a mantra-japa
   */
  patch: (id: number | string, payload: UpdateMantraJapaPayload) =>
    api.patch<MantraJapa>(`/mantra-japa/${id}`, payload),

  /**
   * Update a mantra-japa
   */
  update: (id: number | string, payload: UpdateMantraJapaPayload) =>
    api.put<MantraJapa>(`/mantra-japa/${id}`, payload),

  /**
   * Delete a mantra-japa
   */
  delete: (id: number | string) =>
    api.delete<void>(`/mantra-japa/${id}`),
};

export const mantraJapaFolderApi = {
  getAll: () =>
    api.get<MantraJapaFolder[]>('/mantra-japa-folders').then((res) => {
      const data = unwrapList<MantraJapaFolder>(res.data);
      return { ...res, data };
    }),

  getById: (id: number | string) =>
    api.get<MantraJapaFolder>(`/mantra-japa-folders/${id}`),

  create: (payload: CreateMantraJapaFolderPayload) =>
    api.post<MantraJapaFolder>('/mantra-japa-folders', payload),

  update: (id: number | string, payload: UpdateMantraJapaFolderPayload) =>
    api.patch<MantraJapaFolder>(`/mantra-japa-folders/${id}`, payload),

  delete: (id: number | string) =>
    api.delete(`/mantra-japa-folders/${id}`),
};

export default mantraJapaApi;
